/**
 * Ein Stück, das nicht geladen oder nicht verknüpft werden konnte — im
 * Wortlaut von Safari, Chrome und Firefox (02.10.2026, `Ladefehler.tsx`).
 *
 * Eigene Datei ohne React, damit der Test sie ohne Browser lesen kann.
 */
const LADEFEHLER = /Importing binding name|Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Unable to preload CSS|Loading chunk|ChunkLoadError/i;

export function istLadefehler(fehler: unknown): boolean {
  const satz = fehler instanceof Error ? `${fehler.name} ${fehler.message}` : String(fehler);
  return LADEFEHLER.test(satz);
}
